import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TreatmentRoutingModule } from './treatment-routing.module';
import { TreatmentComponent } from './pages/treatment/treatment.component';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from '../../shared/shared.module';
import { TreatmentListComponent } from './components/treatment-list/treatment-list.component';
import { TreatmentItemComponent } from './components/treatment-item/treatment-item.component';
import { TreatmentWizardModule } from '../treatment-wizard/treatment-wizard.module';
import { TreatmentGroupItemComponent } from './components/treatment-group-item/treatment-group-item.component';

@NgModule({
    declarations: [
        TreatmentComponent,
        TreatmentListComponent,
        TreatmentItemComponent,
        TreatmentGroupItemComponent,
    ],
    imports: [
        CommonModule,
        TreatmentRoutingModule,
        IonicModule,
        SharedModule,
        TreatmentWizardModule,
    ],
    exports: [
        TreatmentComponent
    ]
})
export class TreatmentModule {}
